const createHeightStyle = () => ({
  minHeight: '100vh !important',
});

export const styles = () => ({
  ...createHeightStyle({}),
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
  '.dn-error-text': {
    fontSize: '14px',
    lineHeight: '18px',
    color: '#7B7B7B',
    margin: '30px 0',

    strong: {
      fontSize: '20px',
      lineHeight: '24px',
      color: '#373D3F',
      fontWeight: 'bold',
    },

    a: {
      color: '#0176FF',
      textDecoration: 'none',

      '&:hover': {
        textDecoration: 'underline',
      },
    },
  },
});
